import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// Define types for the data structure
interface DataItem {
  paid_type: string;
  average_er: number;
}

interface BrandErChartProps {
  rawData: DataItem[];
}

const BrandErChart: React.FC<BrandErChartProps> = ({ rawData }) => {
  // Extract values based on type
  const getValue = (type: string) =>
    rawData.find((item) => item.paid_type === type)?.average_er || 0;

  const data = {
    all: getValue("All"),
    paid: getValue("paid"),
    organic: getValue("brand_organic")
  };

  const chartConfig = {
    labels: ["Engagement Rate"],
    datasets: [
      {
        label: "All",
        data: [data.all],
        backgroundColor: "rgb(22, 91, 170)",
        borderRadius: 5,
        barThickness: 20,
        clip: 20,
        barPercentage: 0.6,
        categoryPercentage: 0.5
      },
      {
        label: "Paid",
        data: [data.paid],
        backgroundColor: "rgb(161, 85, 185)",
        borderRadius: 5,
        barThickness: 20,
        clip: 20,
        barPercentage: 0.6,
        categoryPercentage: 0.5
      },
      {
        label: "Organic",
        data: [data.organic],
        backgroundColor: "rgb(24, 150, 97)",
        borderRadius: 5,
        barThickness: 20,
        clip: 20,
        barPercentage: 0.6,
        categoryPercentage: 0.5
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    type:'column',
    maintainAspectRatio: false,
    // indexAxis: "y" as const,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 5,
        display: false
      },
      y: {
        display: false
      }
    },
    layout: {
      padding: {
        bottom: 0,
        right: 20
      }
    }
  };

  return (
    <div style={{ height: "88px", width: "100%" }}>
      <Bar data={chartConfig} options={chartOptions} />
    </div>
  );
};

export default BrandErChart;